import { CreateAircraftMetadataButton } from "@/components/aircraft/CreateAircraftMetadataButton";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import {
  getAircraftMetadata,
  type AircraftMetadata as AircraftMetadataType,
} from "@/queries/landing";

export function AircraftMetadata() {
  const {
    data: metadata,
    isLoading: isLoadingMetadata,
    error: errorMetadata,
  } = getAircraftMetadata();

  if (isLoadingMetadata)
    return <div className="p-4">Loading aircraft metadata...</div>;
  if (errorMetadata)
    return (
      <div className="p-4">
        Error loading aircraft metadata: {errorMetadata.message}
      </div>
    );

  return (
    <Card className="mt-4">
      <CardHeader className="flex flex-row items-center justify-between">
        <div>
          <CardTitle>Aircraft Metadata Records</CardTitle>
          <CardDescription>
            View and manage aircraft metadata entries.
          </CardDescription>
        </div>
        <CreateAircraftMetadataButton />
      </CardHeader>
      <CardContent>
        {metadata?.length === 0 ? (
          <p className="text-center text-muted-foreground py-4">
            No aircraft metadata found.
          </p>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full flight-table text-white">
              <thead>
                <tr className="!text-white font-semibold">
                  <th className="p-2 text-left">Tail Number</th>
                  <th className="p-2 text-left">Aircraft</th>
                  <th className="p-2 text-left">Carrier</th>
                </tr>
              </thead>
              <tbody>
                {metadata?.map((item: AircraftMetadataType) => (
                  <tr key={item.id} className="hover:bg-slate-800/50">
                    <td className="p-2">{item.tail_number}</td>
                    <td className="p-2">
                      {item.aircraft?.model} (
                      {item.aircraft?.code_iata ||
                        item.aircraft?.code_icao ||
                        "N/A"}
                      )
                    </td>
                    <td className="p-2">
                      {item.general_aviation
                        ? "General Aviation"
                        : `${item.carrier?.name} (${item.carrier?.code || "N/A"})`}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </CardContent>
    </Card>
  );
}

// Ensure this default export exists if AirportPage.tsx still expects it, though named export is typical for pages/components.
// export default AircraftMetadata;
// If AircraftMetadata is imported as a named export in AirportPage.tsx, this default export is not strictly necessary.
